// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rim-repair-layout-toolbar{height:160px;padding:18px;background-color:#272727}.rim-repair-layout-icon{cursor:pointer}.rim-repair-layout-title{font-size:30px;text-align:center}.rim-repair-layout-pre-title{font-size:20px;text-align:center}", ""]);
// Exports
module.exports = exports;
